/**
 * Constants chứa các title của các module/trang trong ứng dụng
 * Sử dụng để quản lý title một cách tập trung và dễ bảo trì
 */
export const PAGE_TITLES = {
  // module
  DASHBOARD: 'Dashboard',
  CARD: 'Card',
  PROVIDER: 'Provider',
  USER: 'User',
  TRANSACTION: 'Transaction',
  TRANSACTIONS: 'Transactions',
  ACCOUNT: 'Account',
  EVENT: 'Event',
  AUDIT: 'Audit',
  CUSTOMER: 'Customer',
  DetailCustomer: 'Customer-detail',
  VirtualAccount: 'Virtual Accounts',
  PROFILE: 'Profile',
  SETTINGS: 'Settings',
  CustomerRequest: 'Customer Request',
  CASHBACK: 'Cashback',
  NOTIFICATIONS: 'Notifications',
  NOTIFICATION_SETTINGS: 'Notification settings',

  // Settings sub-pages — values must match `label` from BE settings API
  SETTINGS_PROFILE: 'My Profile',
  SETTINGS_USERS: 'Users',
  SETTINGS_BALANCE_ALERT_RULES: 'Balance Alert Rules',
  SETTINGS_BOT: 'Bot',
  SETTINGS_TRANSACTION_RULES: 'Transaction Notification Rules',
  SETTINGS_COMPANY_PROFILE: 'Company Profile',
  SETTINGS_COMPANY_SECURITY: 'Company Security',
  SETTINGS_PERSONAL_SECURITY: 'Security',
  SETTINGSCOMPANYPROFILE: 'Company Profile',
  SETTINGSCOMPANYSECURITY: 'Company Security',

  // Authentication
  LOGIN: 'Login',
  REGISTER: 'Register',
  VERIFY_CODE: 'Verify Code',
  FORGOT_PASSWORD: 'Forgot Password',
  RESET_PASSWORD: 'Reset Password',

  // User Management
  USERS: 'User',
  USER_PROFILE: 'Personal information',
  USER_ROLES: 'User permissions',

  // Content Management
  CONTENT: 'Content management',
  POSTS: 'Posts',
  CATEGORIES: 'Categories',
  TAGS: 'Tags',

  GENERAL_SETTINGS: 'General settings',
  SYSTEM_SETTINGS: 'System settings',

  // Reports
  REPORTS: 'Reports',
  ANALYTICS: 'Analytics',

  // Error Pages
  NOT_FOUND: 'Not found',
  UNAUTHORIZED: 'Unauthorized',
  SERVER_ERROR: 'Server error',
} as const;

// Type cho các title keys
export type PageTitleKey = keyof typeof PAGE_TITLES;
